import Colors from 'constants/Colors';

export default {
  headerContainer: {
    display: 'flex',
    gap: '1.2rem',
  },
  iconContainer: {
    alignContent: 'center',
  },
  headerTitle: {
    color: Colors.headerTitleColor,
    fontSize: '1.1rem',
    fontWeight: 600,
    paddingTop: '0.5rem',
  },
  headerDescription: {
    color: Colors.headerDescriptionColor,
    fontSize: '0.9rem',
    margin: 0,
    fontWeight: 300,
  },
  backButton: {
    marginBottom: '1.5rem',
    paddingLeft: '0.5rem',
    paddingRight: '0.5rem',
  },
};
